<template>
  <div
    :style="{
      backgroundColor: backgroundColor
    }"
    class="ap-thread-participant-multiple-choice-preview-alert-msg"
  >
    <span
      :style="{
        color: backgroundColor === '#fff' ? '#000' : ''
      }"
      class="alert-message"
    >
      {{ message }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String
    },
    backgroundColor: {
      type: String
    },
    color: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.ap-thread-participant-multiple-choice-preview-alert-msg {
  min-width: 24px;
  min-height: 24px;
  border-radius: 50px;
  margin-left: 10px;
  display: flex;
  align-items: center;

  .alert-message {
    font-size: 11px;
    color: #ffffff;
    padding: 0px 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
    text-align: center;
  }
}
</style>
